<template>
  <div class="title">
    <h1>{{ title }}</h1>
  </div>
</template>

<script>
import firebase from "firebase";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

export default {
  name: "Title",
  props: ["title", "subTitle"],
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss">
.title {
  border-bottom: 2px solid #eaeaea;
  box-sizing: border-box;
  margin-bottom: 10px;
  h1 {
    font-size: 25px;
    margin-top: 0;
    margin-bottom: 10px;
  }
}
</style>
